// Generated by Copilot- Start
import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "../../video-lab/dtv-text";
import DtvGrid from "@directv-digital/dds.ui.dtv-grid";
import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import { IChnlInteractiveThemeUI } from "lib/helper/channel-interactive-tool-theme";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

interface RsnLegalDisclaimerProps {
  theme?: IChnlInteractiveThemeUI;
  additionalInfo?: string;
  showGenrePackages?: boolean;
  rsnLegalText?: string;
}

const styles = {
  channelGrid: {
    display: "block",
    position: "relative"
  }
};

const RsnLegalDisclaimer: React.FC<RsnLegalDisclaimerProps> = ({
  theme,
  additionalInfo,
  showGenrePackages = false,
  rsnLegalText = "Regional Sports Networks and local channels aren't available everywhere and may vary by package and location. You may need to be in your billing region (ZIP Code) to watch them. Most Regional Sports Networks are available in CHOICE™ Package and above."
}) => {
  try {
    return (
      <DtvBox sx={{
 mb: {
 xs: "24px",
sm: "32px",
md: "40px"
}
}}>
        <DtvGrid container item sx={styles.channelGrid}>
          {/* RSN Legal Text */}
          <DtvBox sx={{ textAlign: "center" }}>
            <DtvText
              component="p"
              content={rsnLegalText}
              variant="smalltext"
              sx={{
                paddingTop: {
 xs: "10px",
sm: "12px",
md: "20px"
},
                color: theme?.subheadingLegalTextColor || "#757575",
                textAlign: "center",
                fontSize: { xs: "14px !important" }
              }}
            />
          </DtvBox>

          {/* Additional Instruction Text (hidden for genre packages) */}
          {!showGenrePackages && additionalInfo && (
            <div id="instruction">
              <DtvText
                content={additionalInfo}
                variant="body2"
                sx={{
                  color: theme?.subheadingTextColor || colorPalette.neutral_white.main,
                  display: "block",
                  pl: "16px",
                  minHeight: "26px",
                  textAlign: "center",
                  mx: "auto",
                  mt: {
 xs: "24px",
sm: "16px",
md: "24px"
},
                  mb: {
 xs: "12px",
sm: "16px",
md: "17.5px"
},
                  fontSize: {
 xs: "14px",
sm: "16px"
}
                }}
              />
            </div>
          )}
        </DtvGrid>
      </DtvBox>
    );
  } catch (error) {
    console.error("Error in RsnLegalDisclaimer >> ", error);
    return <ErrorDisplay component="RSN Legal Disclaimer" error={error} />;
  }
};

export default React.memo(RsnLegalDisclaimer);
// Generated by Copilot- End
